import { defineMessages } from 'react-intl';

type MessageKeys = 'sourcesTitle' | 'closeSourcesPopup';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		sourcesTitle: {
			id: 'ai-mate.message-renderer.sources.sources-title',
			defaultMessage: '{sourceCount, plural, one {# Source} other {# Sources}}',
			description: 'Sources title with pluralization',
		},
		closeSourcesPopup: {
			id: 'ai-mate.message-renderer.sources.close-sources-popup',
			defaultMessage: 'Close sources popup',
			description: 'Label for the close button in the sources popup',
		},
	});

export default message;
